import { HomeService } from './../Service/home.service';
import { Global } from './../Service/global.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { takeUntil } from 'rxjs/operators';
import { PublicationsService } from '../Service/publications.service';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { StatistiquesService } from '../Service/statistiques.service';
import { TranslateService } from '@ngx-translate/core';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit,OnDestroy {
  offres: any[];
  slick1: any;

  constructor(public global: Global, private service: HomeService, private translate: TranslateService
    , private publicationService: PublicationsService, private router: Router, private StatistiqueService: StatistiquesService) { }
    popup = {
      title: '',
      content: '',
      url:'',
      variables: ''
    }
    acceuil0 = {
      title: '',
      content: '',
      variables: ''
    }
  acceuil1 = {
    title: '',
    content: '',
    variables: ''
  }
  acceuil2 = {
    title: '',
    content: ''
  }
  acceuil3 = {
    title: '',
    content: '',
    variables: ''
  }
  acceuil4 = {
    title: '',
    content: '',
    variables: ''
  }
  acceuil5 = {
    title: '',
    content: '',
    variables: ''
  }
  acceuil21 = {
    title: '',
    content: '',
    variables:''
  }
  ports = [];
  acceuilVideo = "https://www.w3schools.com/howto/rain.mp4";
  filterActivities = [];
  filterRegions = [];
  mvmnvArrivees;
  mvmnvdeparts;
  dataActualite;
  slick = null;
  currentLg;
  isArab = false;
  lastAnnualReport = null;
  lastMonthReport = null;
  lastSynthese = null;
  regions = [];
  selectedRegion = "";  
  selectedPort = null
  selectedActivite = [];
  selectedPortPath = null;
  showVideo = false;

  // New Mas
  currentUrl
  detailedPort = null;
  maxNumPort =0;
  currentPort =0;
  currentlg
  portLoaded = false;
  cartePort = true;
  ngOnInit(): void {
    this.global.CurentLanguage.pipe(takeUntil(this.global.navigationEnd)).subscribe(lg => {
      this.showVideo = false;
      this.service.getDescription('AccueilVideo',lg.url).subscribe(datas => {
        // let intervald =setInterval(() => {
        //   let iframe = document.getElementById('AccueilVideo') as HTMLIFrameElement;
        //   if(iframe !==undefined && iframe !== null) {
            

        //     //@ts-ignore
        //   //   const videoLink = "https://www.youtube.com/embed/" + datas.value[0].Contenu + "?enablejsapi=1&amp;controls=0&amp;fs=0&amp;iv_load_policy=3&amp;rel=0&amp;showinfo=0&amp;loop=1&amp;playlist=" + datas.value[0].Contenu + "&amp;autoplay=1&amp;mute=1"
        //   // console.log(videoLink);
        //   //   iframe['src'] =videoLink;
        //   //   iframe.setAttribute('data-src',videoLink)
        //     // this.showVideo= true;
        //     clearInterval(intervald);
        //   } 
        // },100)


      });

      lg.code == "ar" ? this.isArab = true : this.isArab = false;
      this.currentlg = lg.code;
      this.currentUrl = lg.url
      this.getStatistiques();
      this.service.getPortnet().subscribe(datas => {
        this.regions =  [];
        datas['value'].forEach(element => {
          const  imgPort = element.AttachmentFiles.length >  0 ? this.global._basedUrl + element.AttachmentFiles[0].ServerRelativeUrl : this.currentlg+"/assets/media/images/port_casa_s.jpg"
          let activites = '';
          element.CodeActivitePortuaire.forEach(item => {
            if(item === 'activite.passagers') {
              activites +="<img src='"+this.currentlg+"/assets/media/images/passager.png'>"
            } else if(item === 'activite.peche') {
              activites +="<img src='"+this.currentlg+"/assets/media/images/p-che.png'>"
            } else if(item === 'activite.Plaisance') {
              activites +="<img src='"+this.currentlg+"/assets/media/images/passager.png'>"
            } else {
              activites +="<img src='"+this.currentlg+"/assets/media/images/commerce.png'>"
            }
          });
          const titre = this.translate.instant(element.CodePort);
          const region = this.translate.instant(element.CodeRegion);
          if (element.GInfo !== null && element.GInfo !== undefined && element.GInfo !== '') {
            const obj = {
              gInfo:this.returnJson(element.GInfo),
              circleInfo:this.returnJson(element.CircleInfo),
              pathInfo:this.returnJson(element.PathInfo),
              codeActivitePortuaire: element.CodeActivitePortuaire,
              CodePort: element.CodePort,
              textInfo:this.returnJson(element.TextInfo),
              CodeRegion: element.CodeRegion,
              activite: activites,
              pathPort: element.CodePort.toLowerCase().split('ports.port')[1],
              portImage: imgPort,
              toolTip : this.returnTitlePort(element), 
              TitleTrans : titre,
              regionTrans: region,
              ordrePort: element.OrdreMap
            }
            this.ports.push(obj);
          }
          if(this.regions.indexOf(element.CodeRegion) === -1) {
            this.regions.push(element.CodeRegion);
          }

        });
      });
      this.service.getDescription('AccueilVideo',lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
       
          this.acceuilVideo = datas['value'][0].Contenu;
      
        }
      });
      this.service.getNotifications(lg.url).subscribe(datas => {
        //if(this.converteDate(a.AcualiteDate))  
        const Today = new Date(); 
        if (datas['value'].length > 0) {          
          datas['value'].forEach(element => {
            if(this.IsTodaybetween(element.DatePublication,element.DateFinPublication,Today))
            {
              this.popup.title = element.Title;
              this.popup.content = this.global._baseUrlStatique+element.File.ServerRelativeUrl;     
              this.popup.url = element.Url     ;
              $('#popupnotification').modal('show');
            }
          }); 
        }
      });
      this.service.getDescription('Accueil0', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil0.title = datas['value'][0].Title;
          this.acceuil0.content = datas['value'][0].Contenu;
          this.acceuil0.variables = datas['value'][0].Variables;
        }
      });
      this.service.getDescription('Accueil21', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil21.title = datas['value'][0].Title;
          this.acceuil21.content = datas['value'][0].Contenu;
          this.acceuil21.variables = datas['value'][0].Variables;
        }
      });
      this.service.getDescription('Accueil1', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil1.title = datas['value'][0].Title;
          this.acceuil1.content = datas['value'][0].Contenu;
          this.acceuil1.variables = datas['value'][0].Variables;
        }
      });
      this.service.getDescription('Accueil2', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil2.title = datas['value'][0].Title;
          this.acceuil2.content = datas['value'][0].Contenu;
        }
      });
      this.service.getDescription('Accueil3', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil3.title = datas['value'][0].Title;
          this.acceuil3.content = datas['value'][0].Contenu;
          this.acceuil3.variables = datas['value'][0].Variables;
        }
      });
      this.service.getDescription('Accueil4', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil4.title = datas['value'][0].Title;
          this.acceuil4.content = datas['value'][0].Contenu;
          this.acceuil4.variables = datas['value'][0].Variables;
        }
      });
      this.service.getDescription('Accueil5', lg.url).subscribe(datas => {
        if (datas['value'].length > 0) {
          this.acceuil5.title = datas['value'][0].Title;
          this.acceuil5.content = datas['value'][0].Contenu;
          this.acceuil5.variables = datas['value'][0].Variables;
        }
      });
      this.dataActualite = [];
      this.offres = [];
      if (this.slick != null) {
        this.slick.slick('destroy');
      }
      forkJoin({
        requestTwo: this.publicationService.getActualite(lg.url, true),
        requestOne: this.publicationService.getOffres(lg.url, true)
      }).subscribe(({ requestOne, requestTwo }) => {
        this.dataActualite = requestTwo["value"];
        this.offres = requestOne["value"];
        setTimeout(() => this.slickContent(lg), 100);
      });
    });
    this.service.getMvmNaviresDeparts().subscribe(data => {
      this.mvmnvdeparts = data;
    })
    this.service.getMvmNaviresArrivees().subscribe(data => {
      this.mvmnvArrivees = data;
    })
  }
  ngOnDestroy(): void {
    $('[data-toggle="tooltip"]').tooltip('dispose');
  }
  nextPort(suivant) {
    let opt = 0
    if(suivant) {
       opt = this.currentPort ===  this.maxNumPort ? this.currentPort = 1 : this.currentPort +1
    } else {
       opt = this.currentPort ===  1 ? this.currentPort = this.maxNumPort : this.currentPort - 1 
    }
    let port;
    this.ports.forEach(element => {
               
      if(element.ordrePort === opt) {
        port = element;
      }
    });
    this.getPortDetail(port);
  }
  getPortDetail(port) {

    
    this.currentPort = port.ordrePort;
    this.portLoaded = false;
     this.detailedPort = {
        port: port,
        mvmEntre: [],
        mvSortie : [],
        links: [],
        chantiers: []
      }
      forkJoin([this.service.getPortSections(), this.service.getChantiersInfrastructures(this.currentUrl)
        , this.service.getMvmNaviresArrivees(),this.service.getMvmNaviresDeparts()]).subscribe(datas => {
          const menuPorts = datas[0]['value']
         const  mvmEntre =datas[2];
          const  mvmSortie =  datas[3];
  
          const requetes = [];
          menuPorts.forEach(section => {
            requetes.push(this.service.getAllServiceDataId(section.ListeReference,this.currentlg));
           });
           forkJoin(requetes).subscribe(dataPorts => {
         
            const pathPort = port.CodePort.toLowerCase().split('ports.port')[1];
            const urlPortStatic = '/services/port/' + pathPort +'/page'
            const mvArrive = [];
            const mvSortie = [];
            const liens = [];
            const gchantiers = [];
            // Grand Chantiers
            datas[1]['value'].forEach(element => {
              if(element.CodePort === port.CodePort) {
                const obj = {
                  Titre: element.Title ? element.Title : "",
                  Port: element.CodePort ? element.CodePort : "",
                  Id: element.Id ? element.Id : "",
                  PortImage: element.LienImageProjet !== '' && element.LienImageProjet !== null ? this.global._basedUrl + element.LienImageProjet : this.currentlg+'assets/media/images/img-01.png'
                }
                gchantiers.push(obj);
              }
            });
            // lien Ports 
            for(let i=0 ; i < dataPorts.length ; i++) {
              if(dataPorts[i]['value'].length > 0) {
                const obj = {
                  'Title': this.currentlg === 'fr' ?  menuPorts[i].Title : this.currentlg ==='ar' ? menuPorts[i].TitleAR : menuPorts[i].TitleEN,
                  'Url': [urlPortStatic,menuPorts[i].ApplicationUrl ]
                }
                liens.push(obj);
              }
            }
            // Liste Entree
            //@ts-ignore
            mvmEntre.forEach(element => {
              if(element.pORTField.toLowerCase()=== port.textInfo.id.toLowerCase() ) {
                mvArrive.push(element);
              }
            });
              //@ts-ignore
            mvmSortie.forEach(element => {
              if(element.pORTField.toLowerCase()=== port.textInfo.id.toLowerCase() ) {
                mvSortie.push(element);
              }
            });
            this.detailedPort.mvmEntre =mvArrive;
            this.detailedPort.mvSortie =mvSortie;
            this.detailedPort.links =liens;
            this.detailedPort.chantiers =gchantiers;
         
            this.portLoaded = true;
            $('.modal-body .accordion').on('shown.bs.collapse', function () {
              if ($('.modal-body .accordion .slick-list').width() == 0) {
               
                setTimeout(() => {
                  $('.card-slider').slick('unslick');
                  $('.card-slider').slick({
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false,
                  });   
                }, 1000)
                 
              }
            })
            document.getElementById('collapseInit').click();
            
            });
        })
     
    } 
  workSlick(chantiers) {
   
    if(chantiers.length > 0) {
      try {
    this.slick !== null ? this.slick = $('.card-slider').slick('unslick') : '';
      } catch {

      }
    this.slick =  $('.card-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
      });
    }
    
  }

  navigateToServicePort(item){
  ;
    document.getElementById('btnCloseModal').click();
    this.router.navigate(item);
  }
  navigateChantier(item){
    
    document.getElementById('btnCloseModal').click();
    this.router.navigate(['/grands-chantiers/chantiers-infrastructures',item.Id]);
  }
  
  returnTitlePort(portItem) {

    const  imgPort = portItem.AttachmentFiles.length >  0 ? this.global._basedUrl + portItem.AttachmentFiles[0].ServerRelativeUrl : this.currentlg+"/assets/media/images/port_casa_s.jpg"
    let activites = '';
    portItem.CodeActivitePortuaire.forEach(element => {
      if(element === 'activite.passagers') {
        activites +="<img src='"+this.currentlg+"/assets/media/images/passager.png'>"
      } else if(element === 'activite.peche') {
        activites +="<img src='"+this.currentlg+"/assets/media/images/p-che.png'>"
      } else if(element === 'activite.Plaisance') {
        activites +="<img src='"+this.currentlg+"/assets/media/images/passager.png'>"
      } else {
        activites +="<img src='"+this.currentlg+"/assets/media/images/commerce.png'>"
      }
    });
    const titre = this.translate.instant(portItem.CodePort);
    const region = this.translate.instant(portItem.CodeRegion);

    return "<div class='visuel'><img width='320' height='120' src='"+imgPort + "'></div><div class='tooltip-content d-flex flex-column justify-content-between'><div class='services align-self-start w-100'>"+activites +"</div><div class='align-self-end w-100'><div class='titre'>"+ titre +"</div><div class='p'>"+region+"</div></div></div>";
    
  

    
  }
  tooltiphover(){
    setTimeout(() => {
      $('[data-toggle="tooltip"]').tooltip();
    }, 100);
  }
  IsTodaybetween(from,to,check)
  {    
      var fDate,lDate,cDate;
      fDate = Date.parse(from);
      lDate = Date.parse(to);
      cDate = Date.parse(check);
  
      if((cDate <= lDate && cDate >= fDate)) {
          return true;
      }
      return false;  
  }
  onYouTubeIframeAPIReady(youtubeCode) {
    var player;
    $(document).ready(function () {
      //@ts-ignore
      player = new YT.Player('muteYouTubeVideoPlayer', {
        videoId: youtubeCode, // YouTube Video ID
        width: screen.width, // Player width (in px)
        height: screen.height-100, // Player height (in px)
        playerVars: {
          autoplay: 1, // Auto-play the video on load
          controls: 1, // Show pause/play buttons in player
          showinfo: 0, // Hide the video title
          modestbranding: 1, // Hide the Youtube Logo
          loop: 1, // Run the video in a loop
          fs: 0, // Hide the full screen button
          cc_load_policty: 0, // Hide closed captions
          iv_load_policy: 3, // Hide the Video Annotations
          autohide: 0 // Hide video controls when playing
        },

        events: {
          onReady: function (e) {
            e.target.mute();
          },
          onStateChange: function (e) {
            //@ts-ignore
            if (e.data === YT.PlayerState.ENDED) {
              player.playVideo();
            }
          }
        }
      });
    });

  }

  returnJson(obj) {
    if (obj === null || obj === undefined || obj === '') {
      return null;
    } else {
      try {
        return JSON.parse(obj);
      } catch {
        return null
      }
    }
  }
  filterPortByActivities(filter) {
    if (this.filterActivities.indexOf(filter) === -1) {
      this.filterActivities[0] = filter
    } else {
      this.filterActivities.pop();
    }
    // if (this.filterActivities.indexOf(filter) === -1) {
    //   this.filterActivities.push(filter);
    // } else {
    //   _.remove(this.filterActivities, function (currentObject) {
    //     return currentObject === filter;
    //   });
    // }
  }
  filterPortByRegion(filter) {
    if (this.filterRegions.indexOf(filter) === -1) {
      this.filterRegions.push(filter);
    } else {
      _.remove(this.filterRegions, function (currentObject) {
        return currentObject === filter;
      });
    }
  }
  resetContentLanguage() {
    this.acceuil1 = {
      title: '',
      content: '',
      variables: ''
    }
    this.acceuil2 = {
      title: '',
      content: ''
    }
    this.acceuil3 = {
      title: '',
      content: '',
      variables: ''
    }
    this.acceuil4 = {
      title: '',
      content: '',
      variables: ''
    }
    this.acceuil5 = {
      title: '',
      content: '',
      variables: ''
    }
  }
  convertTime(t) {
    return new Date(+t.split("(")[1].split(")")[0].split("+")[0]).toLocaleTimeString().substring(0, 5)
  }

  slickContent(lg) {
    if (lg.code != "ar") {
      this.slick = $('.slickContent').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
    else {
      this.slick = $('.slickContent').slick({
        rtl: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              infinite: true,
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  }

  getLine(s: string,num) {
    if(s?.length>num){
      return s.substr(0, num) + "...";
    }else
    { return s}
  }
  converteDate(d: string) {
    return this.global.formattedDate(d);
  }
  navigateTo(port) {
    this.router.navigate(['/port', port.pathPort,'page','Presentation']);
  }
  substring(str: string) {
    return str.substring(0, 120) + "...";
  }
  capetalize(str: string) {
    return str.charAt(0).toUpperCase() + str.toLowerCase().substring(1, 120) + "...";
  }
  modal(url: string) {
    $("#video").attr('src', url + "?autoplay=1&amp;modestbranding=1&amp;showinfo=0");
    $("#myModal").modal("show");
    $('#myModal').on('hide.bs.modal', (e) => {
      $("#video").attr('src', "");
    })
  }
  scrollToPropos(el: HTMLElement) {
    el.scrollIntoView();
  }
  getStatistiques() {
    forkJoin(
      [
        this.StatistiqueService.getRapportDeSyntheseLastOne(this.global._basedUrl+ this.global._FrUrl),
        this.StatistiqueService.getStatistiqueAnnuelLastOne(this.global._basedUrl+ this.global._FrUrl),
        this.StatistiqueService.getStatistiqueMensuelleLastOne(this.global._basedUrl+ this.global._FrUrl),
      ]
    ).subscribe(datas => {
     this.lastSynthese = datas[0]['value'] !== null && datas[0]['value'] !== undefined ? datas[0]['value'][0] : null
     this.lastAnnualReport = datas[1]['value'] !== null && datas[1]['value'] !== undefined ? datas[1]['value'][0] : null
     if(datas[2]['value'] !== null  && datas[2]['value'] !== undefined  &&  datas[2]['value'].length > 0 ) {
      const lastYear = datas[2]['value'][0].Annee;
      let lastMonth = 0;
      let index = 0;
      let indexElmnt = 0;
      datas[2]['value'].forEach(element => {
        if(element.Annee === lastYear) {
          if(element.Mois !== null && element.Mois !== undefined && (+element.Mois) > lastMonth) {
            indexElmnt = index;
          }
        }
        index ++;
      });
      this.lastMonthReport = datas[2]['value'][indexElmnt];
 

     } else {
       this.lastMonthReport = null;
     }
   
    })
  }
  downloadTarget(target) {

    if (target !== null && target.File !== undefined) {

      const targetLink = this.global._baseUrlStatique + target.File.ServerRelativeUrl;
      var redirect = window.open(targetLink, '_blank');
      redirect.location;
    }
  }
  ReturnPortName(portCode){
    return 'portName.' + portCode.split('.')[1];
  }
  ngAfterViewInit() {

    var checkExist = setInterval(function () {
      if ($('[data-toggle="tooltip"]').length > 0){
     
        clearInterval(checkExist);
       
        if ($('[data-toggle="tooltip"]').length > 0){
          $('[data-toggle="tooltip"]').tooltip();
        
        }
        $('[data-toggle="tooltip"]').on('show.bs.tooltip', function (e) {
          $("div.tooltip-inner > div.visuel > img").on("load",()=>{
            $(this).tooltip('update');
          })
        })
        $('tspan').on('click', function (e) {
          $(this).addClass('active');
          var portID = $(this).parent().attr('id');
          $('circle#'+portID).addClass('active');
        })
        $('.modal').on('hidden.bs.modal', function (event) {
          $('tspan').removeClass('active');
          $('circle').removeClass('active');
        })
  
      }

    },100);
  }
  changeRegion() {
    this.selectedPort = null;
    this.selectedActivite = [];
    this.selectedPortPath = null;
  }
  getPortActivity(item) {
    
    if (item !== null) {
      this.ports.forEach(element => {
        if(element.CodePort === item) {
          this.selectedActivite =  element.codeActivitePortuaire;
          this.selectedPortPath = element;
        }
      });
    } else {
      this.selectedActivite =  [];
    }
    
  }
  
}
